import type { AuthResponse } from '@/types/user';

import { apiClient, apiRequest } from '../api/client';
import type { ApiResult } from '../api/types';

export type ChangePasswordData = {
  currentPassword: string;
  newPassword: string;
};

export type RequestEmailChangeData = {
  newEmail: string;
};

export async function changePassword(
  data: ChangePasswordData
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.post<{ message: string }>('/auth/change-password', data)
  );
}

export async function requestEmailChange(
  data: RequestEmailChangeData
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.post<{ message: string }>('/auth/request-email-change', data)
  );
}

export async function confirmEmailChange(
  token: string
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() =>
    apiClient.get<AuthResponse>(`/auth/confirm-email-change/${token}`)
  );
}

export type ApproveUserResponse = {
  message: string;
  alreadyApproved?: boolean;
};

export async function approveUserByToken(
  token: string
): Promise<ApiResult<ApproveUserResponse>> {
  return apiRequest(() =>
    apiClient.get<ApproveUserResponse>(`/auth/approve/${token}`)
  );
}
